import {
  map
} from 'rxjs/operators';
import {
  Injectable
} from "@angular/core";
import {
  UserDnaClient
} from "@app/models/dna/dna.user-dna-client.model";
import {
  HttpClient
} from "@angular/common/http";
import {
  DnaClient,
  DnaClientWithUserPermissions
} from "@app/models/dna/dna.client.model";
import {
  DnaProductLibrary
} from "@app/models/dna/dna.product-library.model";
import {
  Manufacturer
} from "@app/models/dna/dna.manufacturer.model";
import {
  DnaType
} from "@app/models/dna/dna.type.model";
import {
  DnaProduct
} from "@app/models/dna/dna.product.model";
import {
  DnaProductLibraryHeader
} from "@app/models/dna/dna.product-library-header.model";
import {
  DnaProductHeader
} from "@app/models/dna/dna.product-header.model";
import {
  DnaAdministrationUser
} from "@app/models/dna/dna.administration-user.model";
import {
  DnaAutomationSection
} from "@app/models/dna/dna.automation-section.model";
import {
  DnaTagWithValue
} from "@app/models/dna/dna.tag-with-value.model";
import {
  DnaDevice
} from "@app/models/dna/dna.device.model";
import {
  DnaAssignedProduct
} from "@app/models/dna/dna.assigned-product.model";
import {
  DnaProductData
} from "@app/models/dna/dna.product-data.model";
import {
  GenerateDnaReportParam
} from "@app/models/dna/dna.generated-dna-report-param.model";
import {
  CloudDriveProvider
} from "@app/models/clouddrive/clouddrive-provider.model";
import {
  CloudDriveService
} from "@app/services/clouddrive/clouddrive.service";
import {
  ImportTagsFromDiscipline
} from "@app/models/dna/dna.ImportTagsFromDiscipline-param.model";
import {
  FunctionValidationResult
} from "@app/models/function-validation/function-validation-result";
import {
  DeviceGroupEditRequestViewModel,
  DeviceGroupEditViewModel,
  DeviceGroupSearchRequestViewModel,
  DeviceGroupViewModel
} from "@app/models/dna/dna.device-group.models";

@Injectable({providedIn: "root"})

export class DnaModuleService {
  private service = "DnaService";

  private isFileBeingStreamed: boolean = false;

  constructor(private http: HttpClient,
              public cloudDriveService: CloudDriveService) {
  }

  public getDnaClientsOfUserWithPermissionLevel(permissionLevel: number) {
    return this.http.get<DnaClient[]>(`api/${this.service}/GetAllDnasOfUser/${permissionLevel}`);
  }

  public getUserDnaClientByUserClient() {
    return this.http.get<DnaClient[]>(`api/${this.service}/GetUserDnaClientByUserClient`);
  }

  public getDnaClientsOfUserWithPermissionLevelForAdmin(permissionLevel: number) {
    return this.http.get<DnaClient[]>(`api/${this.service}/GetAllDnasOfUserForAdmin/${permissionLevel}`);
  }

  public getAllavailableDnaClientsOfUserForDnaManagement() {
    return this.http.get<DnaClientWithUserPermissions[]>(
      `api/${this.service}/GetAllavailableDnaClientsOfUserForDnaManagement`);
  }

  public getAvailableProductLibrariesForListing() {
    return this.http.get<DnaProductLibrary[]>(`api/${this.service}/GetAvailableProductLibrariesForListing`);
  }

  public addNewDnaClient(dna: DnaClient) {
    return this.http.post(`api/${this.service}/AddDnaClient`, dna);
  }

  public deleteDnaClient(dna: DnaClient) {
    return this.http.delete<any>(`api/${this.service}/DeleteDnaClient/${dna.id}`, {responseType: "json"});
  }

  public updateDnaClient(dna: DnaClient) {
    return this.http.put(`api/${this.service}/UpdateDnaClient`, dna);
  }

  public getManufacturers() {
    return this.http.get<Manufacturer[]>(`api/${this.service}/GetManufacturers`);
  }

  public canUserEditDna(dnaClientId: number) {
    return this.http.get<boolean>(`api/${this.service}/CanUserEditDna/${dnaClientId}`);
  }

  public getDnaClientProductManufacturers(dnaClientId: number, typeId: number) {
    return this.http.get<Manufacturer[]>(
      `api/${this.service}/GetDnaClientProductManufacturers/${dnaClientId}/${typeId}`);
  }

  public getUserListForDnaAdministrationPage() {
    return this.http.get<DnaAdministrationUser[]>(`api/${this.service}/GetUserListForDnaAdministrationPage`);
  }

  public getProductLibrariesByManufacturerId(manufId: number) {
    return this.http.get<DnaProductLibrary[]>(`api/${this.service}/GetProductLibrariesByManufacturerId/${manufId}`);
  }

  public getProductLibrariesByManufacturerIdTypeIdAndDnaClientId(manufId: number, typeId: number, dnaClientId: number) {
    return this.http.get<DnaProductLibrary[]>(
      `api/${this.service}/GetProductLibrariesByManufacturerIdTypeIdAndDnaClientId/${manufId}/${typeId}/${dnaClientId}`);
  }

  public getNotUsedHardwareProductLibraryTypes(manufId: number) {
    return this.http.get<DnaType[]>(`api/${this.service}/GetNotUsedHardwareProductLibraryTypes/${manufId}`);
  }

  public getProductsByLibrary(libraryId: number) {
    return this.http.get<Array<DnaProduct>>(`api/${this.service}/GetProductsByLibrary/${libraryId}`);
  }

  public getProductLibraryHeadersByLibraryId(libraryId: number) {
    return this.http.get<Array<DnaProductLibraryHeader>>(
      `api/${this.service}/ProductLibraryHeadersByLibraryId/${libraryId}`);
  }


  public getGlobalProductLibraryParameters() {
    return this.http.get<Array<DnaProductLibraryHeader>>(
      `api/${this.service}/GetGlobalProductLibraryParameters`);
  }

  public getProductLibraryTypesByLibraryId(libraryId: number) {
    return this.http.get<Array<DnaProductLibrary>>(
      `api/${this.service}/GetProductLibraryTypesByLibraryId/${libraryId}`);
  }

  public getProductLibraryTypesByLibraryAndManufacturer(libraryId: number, manufacturerId: number) {
    return this.http.get<Array<DnaProductLibrary>>(
      `api/${this.service}/GetProductLibraryTypesByLibraryAndManufacturer/${libraryId}/${manufacturerId}`);
  }

  public getProductHeaders(productId: number) {
    return this.http.get<Array<DnaProductHeader>>(`api/${this.service}/GetProductHeaders/${productId}`);
  }

  public addProduct(product: DnaProduct) {
    return this.http.post<DnaProduct>(`api/${this.service}/AddProduct`, product);
  }

  public updateProduct(product: DnaProduct) {
    return this.http.put<DnaProduct>(`api/${this.service}/UpdateProduct`, product, {responseType: "json"});
  }

  public updateProductHeadersForEditProduct(product: DnaProductHeader[]) {
    return this.http.put<DnaProductHeader[]>(`api/${this.service}/UpdateProductHeadersForEditProduct`,
      product,
      {responseType: "json"});
  }

  public updateUserDnaClient(userDnaClient: UserDnaClient) {
    return this.http.put<DnaProductHeader[]>(`api/${this.service}/UpdateUserDnaClient`,
      userDnaClient,
      {responseType: "json"});
  }

  public deleteUserDnaClient(id: number) {
    return this.http.delete<any>(`api/${this.service}/DeleteUserDnaClient/${id}`, {responseType: "json"});
  }

  public addUserDnaClient(userDnaClient: UserDnaClient) {
    return this.http.post<UserDnaClient>(`api/${this.service}/AddUserDnaClient`, userDnaClient);
  }

  public addProductHeadersFromProductLibraryHeaders(headers: Array<DnaProductLibraryHeader>) {
    return this.http.post(`api/${this.service}/AddProductHeadersFromProductLibraryHeaders`, headers);
  }

  public addProductLibraryWithHeaderValues(param: DnaProductLibrary) {
    return this.http.post<DnaProductLibrary>(`api/${this.service}/AddProductLibraryWithHeaderValues`, param);
  }

  //public addProductLibrary(param: DnaProductLibrary) {
  //  return this.http.post<DnaProductLibrary>(`api/${this.service}/AddProductLibrary`, param);
  //}

  public addProductLibraryHeader(param: DnaProductLibraryHeader) {
    return this.http.post<DnaProductLibraryHeader>(`api/${this.service}/AddProductLibraryHeader`, param);
  }

  public addManufacturer(manufacturer: Manufacturer) {
    return this.http.post<Manufacturer>(`api/${this.service}/AddManufacturer`, manufacturer);
  }

  public updateProductLibraryHeader(param: DnaProductLibraryHeader) {
    return this.http.put<DnaProductLibraryHeader>(`api/${this.service}/UpdateProductLibraryHeader`,
      param,
      {responseType: "json"});
  }

  public deleteManufacturer(manufacturer: Manufacturer) {
    return this.http.delete<any>(`api/${this.service}/DeleteManufacturer/${manufacturer.id}`, {responseType: "json"});
  }

  public deleteProductLibrary(id: number) {
    return this.http.delete<any>(`api/${this.service}/DeleteProductLibrary/${id}`, {responseType: "json"});
  }

  public deleteProductLibraryHeader(id: number) {
    return this.http.delete<any>(`api/${this.service}/DeleteProductLibraryHeader/${id}`, {responseType: "json"});
  }

  public deleteProduct(id: number) {
    return this.http.delete<any>(`api/${this.service}/DeleteProduct/${id}`, {responseType: "json"});
  }

  public deleteProductHeader(id: number) {
    return this.http.delete<any>(`api/${this.service}/DeleteProductHeader/${id}`, {responseType: "json"});
  }

  public getSectionsByDiscipline(disciplineId: number) {
    return this.http.get<DnaAutomationSection[]>(`api/${this.service}/GetSectionsByDiscipline/${disciplineId}`);
  }

  public getDnaTypesByDisciplineAndSection(sectionId: number, disciplineId: number) {
    return this.http.get<DnaType[]>(
      `api/${this.service}/GetDnaTypesByDisciplineAndSection/${sectionId}/${disciplineId}`);
  }

  public getDnaTypesByDisciplineAndSectionIfTypeHasChildItems(dnaClientId: number, sectionId: number, disciplineId: number) {
    return this.http.get<DnaType[]>(
      `api/${this.service}/GetDnaTypesByDisciplineAndSectionIfTypeHasChildItems/${dnaClientId}/${sectionId}/${disciplineId}`);
  }

  public getDnaTypesByDisciplineAndSectionAndConfigurationIfTypeHasChildItems(dnaClientId: number, sectionId: number, disciplineId: number, configurationId: number) {
    return this.http.get<DnaType[]>(
      `api/${this.service}/getDnaTypesByDisciplineAndSectionAndConfigurationIfTypeHasChildItems/${dnaClientId}/${sectionId}/${disciplineId}/${configurationId}`);
  }

  public getDnaTypeTagsWithValue(dnaClientId: number, typeId: number) {
    return this.http.get<DnaTagWithValue[]>(`api/${this.service}/GetDnaTypeTagsWithValue/${dnaClientId}/${typeId}`);
  }

  public updateDnaValue(dna: DnaTagWithValue) {
    return this.http.put<DnaTagWithValue>(`api/${this.service}/UpdateDnaValue`, dna, {responseType: "json"});
  }

  public getDevicesByTypeId(dnaClientId, typeId) {
    return this.http.get<DnaDevice[]>(`api/${this.service}/GetDevicesByTypeId/${dnaClientId}/${typeId}`);
  }

  public getAssignedProductToDevice(dnaClientId: number, deviceId: number) {
    return this.http.get<DnaProduct>(`api/${this.service}/GetAssignedProductToDevice/${dnaClientId}/${deviceId}`);
  }

  public addDevice(device: DnaDevice) {
    return this.http.post<DnaDevice>(`api/${this.service}/AddDevice`, device);
  }

  public updateDevice(device: DnaDevice) {
    return this.http.put<DnaDevice>(`api/${this.service}/UpdateDevice`, device, {responseType: "json"});
  }

  public deleteDevice(deviceId: number) {
    return this.http.delete<any>(`api/${this.service}/DeleteDevice/${deviceId}`, {responseType: "json"});
  }

  public assignNewProduct(assignedProduct: DnaAssignedProduct) {
    return this.http.post<DnaAssignedProduct>(`api/${this.service}/AssignNewProduct`,
      assignedProduct,
      {responseType: "json"});
  }

  public updateAssignedProduct(assignedProduct: DnaAssignedProduct) {
    return this.http.put<DnaAssignedProduct>(`api/${this.service}/UpdateAssignedProduct`,
      assignedProduct,
      {responseType: "json"});
  }

  public getDnaProductTagsWithValue(productId: number, dnaClientId: number, deviceId: number) {
    return this.http.get<DnaProductData[]>(
      `api/${this.service}/GetDNAProductTagsWithValue/${productId}/${dnaClientId}/${deviceId}`);
  }

  public addProductData(productData: DnaProductData) {
    return this.http.post<DnaProductData>(`api/${this.service}/AddProductData`, productData);
  }

  public updateProductData(productData: DnaProductData) {
    return this.http.put<DnaProductData>(`api/${this.service}/UpdateProductData`,
      productData,
      {responseType: "json"});
  }

  public deleteProductData(id: number) {
    return this.http.delete<any>(`api/${this.service}/DeleteProductData/${id}`, {responseType: "json"});
  }

  public unlockProductData(id: number) {
    return this.http.put<any>(`api/${this.service}/UnlockProductData/${id}`, {responseType: "json"});
  }

  public uploadFile(file, deviceId) {
    return this.http.post(`api/${this.service}/UploadDataSheet/${deviceId}`, file, {
      reportProgress: true,
      observe: 'events'
    });
  }


  public generateDnaReport(param: GenerateDnaReportParam): any {
    if (this.isFileBeingStreamed)
      return this.runGenerateReportAndReturnFile(param);
    else
      return this.runGenerateReportAndReturnSuccessMessage(param);
  };

  public importTagsFromDiscipline(param: ImportTagsFromDiscipline): any {
    return this.http.put(`api/${this.service}/ImportTagsFromDiscipline`, param);
  };

  public setFileBeingStreamed() {
    this.cloudDriveService.getUserProvider().subscribe(provider => {
      this.isFileBeingStreamed = provider === CloudDriveProvider.Cloud;
    });
  }

  private runGenerateReportAndReturnFile(generateDnaReportParam: GenerateDnaReportParam) {
    return this.http.post(`api/${this.service}/GenerateDnaReport`,
      JSON.stringify(generateDnaReportParam),
      {
        responseType: "blob",
        observe: "response"
      }).pipe(
      map(res => ({
        content: res != null ? res.body : null,
        fileName: res != null
          ? res.headers.get("content-disposition").split(";")[1].trim().split("=")[1].replace(/"/g, "")
          : ""
      })));
  }

  private runGenerateReportAndReturnSuccessMessage(generateDnaReportParam: GenerateDnaReportParam) {
    return this.http.post(`api/${this.service}/GenerateDnaReport`,
      JSON.stringify(generateDnaReportParam),
      {
        responseType: "json",
        observe: "response"
      });
  }

  public unlockProductHeader(id) {
    return this.http.post(`api/${this.service}/UnlockProductHeader/${id}`,
      {responseType: "json"});
  }

  public unlockProductLibraryHeader(id) {
    return this.http.post(`api/${this.service}/UnlockProductLibraryHeader/${id}`,
      {responseType: "json"});
  }

  public updateDoucmentGeneratorTemplate(dnaClientId: number, documentGeneratorTemplate: string) {
    return this.http.put(`api/${this.service}/UpdateDocumentGeneratorTemplate`,
      {
        id: dnaClientId,
        documentGeneratorTemplate
      });
  }

  public getDocumentGeneratorTemplateFileName(id: number): any {
    return this.http.get(`api/${this.service}/GetDocumentGeneratorTemplateFileName/${id}`);
  }

  public exportDna(dnaClientId: number, includeProductSheets: boolean) {
    return this.http.get(`api/${this.service}/ExportDna/${dnaClientId}/${includeProductSheets}`);
  }

  public importDnaExportFiles(dnaClientId: number, uploadedFile: string) {
    return this.http.post<any>(`api/${this.service}/ImportDna/${dnaClientId}`, JSON.stringify(uploadedFile));
  }

  public analiseDnaExportFiles(dnaClientId: number, uploadedExportFile: string) {
    return this.http.post<any>(`api/${this.service}/AnaliseDnaExportFiles/${dnaClientId}`, JSON.stringify(uploadedExportFile));
  }

  public validateDnaExportFiles(dnaClientId: number, uploadedExportFile: string) {
    return this.http.post<Array<FunctionValidationResult>>(`api/${this.service}/ValidateDnaExportFiles/${dnaClientId}`, JSON.stringify(uploadedExportFile));
  }

  public addDeviceGroup(model: DeviceGroupEditRequestViewModel) {
    return this.http.post(`api/${this.service}/AddDeviceGroup`, model);
  }

  public searchDeviceGroups(model: DeviceGroupSearchRequestViewModel) {
    let params: Record<string, any> = {
      showAll: model.showAll
    };
    if (model.dnaClientId != null) {
      params.dnaClientId = model.dnaClientId;
    }
    if (model.disciplineId != null) {
      params.disciplineId = model.disciplineId;
    }
    return this.http.get<DeviceGroupViewModel[]>(`api/${this.service}/SearchDeviceGroups`, {
      params: params
    });
  }

  public getDeviceGroupEdit(id: number) {
    return this.http.get<DeviceGroupEditViewModel>(`api/${this.service}/GetDeviceGroupEdit/${id}`)
  }

  public updateDeviceGroup(id: number, model: DeviceGroupEditRequestViewModel) {
    return this.http.put(`api/${this.service}/UpdateDeviceGroup/${id}`, model);
  }

  public deleteDeviceGroup(id: number) {
    return this.http.delete(`api/${this.service}/DeleteDeviceGroup/${id}`)
  }

  public restoreDeviceGroup(id: number) {
    return this.http.put(`api/${this.service}/RestoreDeviceGroup/${id}`, {})
  }

  public exportSystemSoftwareParameters(request: { dnaClientId: number; disciplineId: number; exportAll: boolean; systemTypeIds: number[] }) {
    return this.http.post(`api/${this.service}/ExportSystemSoftwareParameters`, request);
  }
}
